<script setup>
/* Props */
const props = defineProps({
  content: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <g-copy
    id="js__product__availability"
    class="app__product__availability"
    type="small"
    mb="none"
    v-html="props.content"
  />
</template>

<style lang="scss" scoped>
.app__product__availability {

  img {
    vertical-align: middle;
  }
}
</style>
